module.exports = __webpack_public_path__ + "static/img/img3.628e805.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/img3.png
// module id = FR2a
// module chunks = 0